<a *ngIf="isLink(item) && !item.isExternal && !isFunction(item.route) && item.hasRole && item.hasRole.indexOf(userRole) != -1 && item.visible"
   [fragment]="item.fragment"
   [routerLinkActiveOptions]="item.routerLinkActiveOptions || { exact: false }"
   [routerLink]="item.route"
   class="vex-sidenav-item"
   matRipple
   matRippleColor="var(--sidenav-item-ripple-color)"
   routerLinkActive="vex-sidenav-item--active">
  <mat-icon *ngIf="level === 0 && item.icon.indexOf('mat:') !== -1" [svgIcon]="item.icon" class="vex-sidenav-item__icon"></mat-icon>
  <mat-icon *ngIf="level === 0 && item.icon.indexOf('fas:') !== -1" [fontIcon]="item.icon.substring(item.icon.indexOf(':')+1)" class="icon vex-sidenav-item__icon" fontSet="fas"></mat-icon>
  <mat-icon *ngIf="level === 0 && item.icon.indexOf('fa:') !== -1" [fontIcon]="item.icon.substring(item.icon.indexOf(':')+1)" class="icon vex-sidenav-item__icon" fontSet="fa"></mat-icon>
  <mat-icon *ngIf="item.icon.indexOf('fa-duotone:') !== -1" [fontIcon]="item.icon.substring(item.icon.indexOf(':')+1)" class="icon vex-sidenav-item__icon" fontSet="fa-duotone"></mat-icon>
  <span class="vex-sidenav-item__label">{{ item.label | translate }}</span>
  <span *ngIf="item.badge"
        [ngClass]="[item.badge.bgClass, item.badge.textClass]"
        class="vex-sidenav-item__badge">{{ item.badge.value }}</span>
</a>

<a *ngIf="isLink(item) && item.isExternal && !isFunction(item.route) && item.hasRole && item.hasRole.indexOf(userRole) != -1 && item.visible"
   [routerLinkActiveOptions]="item.routerLinkActiveOptions || { exact: false }"
   (click)="goToLink(item.route)"
   class="vex-sidenav-item"
   matRipple
   matRippleColor="var(--sidenav-item-ripple-color)"
   routerLinkActive="vex-sidenav-item--active">
    <mat-icon *ngIf="level === 0 && item.icon.indexOf('mat:') !== -1" [svgIcon]="item.icon" class="vex-sidenav-item__icon"></mat-icon>
    <mat-icon *ngIf="level === 0 && item.icon.indexOf('fas:') !== -1" [fontIcon]="item.icon.substring(item.icon.indexOf(':')+1)" class="icon vex-sidenav-item__icon" fontSet="fas"></mat-icon>
    <mat-icon *ngIf="level === 0 && item.icon.indexOf('fa:') !== -1" [fontIcon]="item.icon.substring(item.icon.indexOf(':')+1)" class="icon vex-sidenav-item__icon" fontSet="fa"></mat-icon>
    <mat-icon *ngIf="level === 0 && item.icon.indexOf('fa-duotone:') !== -1" [fontIcon]="item.icon.substring(item.icon.indexOf(':')+1)" class="icon vex-sidenav-item__icon" fontSet="fa-duotone"></mat-icon>
    <span class="vex-sidenav-item__label">{{ item.label | translate }}</span>
    <span *ngIf="item.badge"
          [ngClass]="[item.badge.bgClass, item.badge.textClass]"
          class="vex-sidenav-item__badge">{{ item.badge.value }}</span>
</a>


<div (click)="item.route() && item.hasRole && item.hasRole.indexOf(userRole) != -1 && item.visible"
     *ngIf="isLink(item) && isFunction(item.route)"
     class="vex-sidenav-item"
     matRipple
     matRippleColor="var(--sidenav-item-ripple-color)"
     routerLinkActive="vex-sidenav-item--active">
  <mat-icon *ngIf="level === 0 && item.icon.indexOf('mat:') !== -1" [svgIcon]="item.icon" class="vex-sidenav-item__icon"></mat-icon>
  <mat-icon *ngIf="level === 0 && item.icon.indexOf('fas:') !== -1" [fontIcon]="item.icon.substring(item.icon.indexOf(':')+1)" class="icon vex-sidenav-item__icon" fontSet="fas"></mat-icon>
  <mat-icon *ngIf="level === 0 && item.icon.indexOf('fa:') !== -1" [fontIcon]="item.icon.substring(item.icon.indexOf(':')+1)" class="icon vex-sidenav-item__icon" fontSet="fa"></mat-icon>
  <mat-icon *ngIf="level === 0 && item.icon.indexOf('fa-duotone:') !== -1" [fontIcon]="item.icon.substring(item.icon.indexOf(':')+1)" class="icon vex-sidenav-item__icon" fontSet="fa-duotone"></mat-icon>
  <span class="vex-sidenav-item__label">{{ item.label | translate }}</span>
  <span *ngIf="item.badge"
        [ngClass]="[item.badge.bgClass, item.badge.textClass]"
        class="vex-sidenav-item__badge">{{ item.badge.value }}</span>
</div>

<ng-container *ngIf="isDropdown(item) && item.hasRole && item.hasRole.indexOf(userRole) != -1">
  <div (click)="toggleOpen()"
       [class.vex-sidenav-item--active]="isOpen || isActive"
       [class.vex-sidenav-item--open]="isOpen"
       class="vex-sidenav-item"
       matRipple
       matRippleColor="var(--sidenav-item-ripple-color)">
    <mat-icon *ngIf="level === 0 && item.icon.indexOf('mat:') !== -1" [svgIcon]="item.icon" class="vex-sidenav-item__icon"></mat-icon>
    <mat-icon *ngIf="level === 0 && item.icon.indexOf('fas:') !== -1" [fontIcon]="item.icon.substring(item.icon.indexOf(':')+1)" class="icon vex-sidenav-item__icon" fontSet="fas"></mat-icon>
    <mat-icon *ngIf="level === 0 && item.icon.indexOf('fa:') !== -1" [fontIcon]="item.icon.substring(item.icon.indexOf(':')+1)" class="icon vex-sidenav-item__icon" fontSet="fa"></mat-icon>
    <mat-icon *ngIf="level === 0 && item.icon.indexOf('fa-duotone:') !== -1" [fontIcon]="item.icon.substring(item.icon.indexOf(':')+1)" class="icon vex-sidenav-item__icon" fontSet="fa-duotone"></mat-icon>
    <span class="vex-sidenav-item__label">{{ item.label | translate}}</span>
    <span *ngIf="item.badge"
          [ngClass]="[item.badge.bgClass, item.badge.textClass]"
          class="vex-sidenav-item__badge">{{ item.badge.value }}</span>
    <mat-icon class="vex-sidenav-item__dropdown-icon" svgIcon="mat:keyboard_arrow_right"></mat-icon>
  </div>
  <div [@dropdown]="isOpen" class="vex-sidenav-item__dropdown">
    <vex-sidenav-item *ngFor="let subItem of item.children" [item]="subItem" [level]="level + 1"></vex-sidenav-item>
  </div>
</ng-container>


<ng-container *ngIf="isSubheading(item) && item.hasRole && item.hasRole.indexOf(userRole) != -1">
  <div class="vex-sidenav-subheading">{{ item.label | translate }}</div>
  <vex-sidenav-item *ngFor="let subItem of item.children" [item]="subItem" [level]="0"></vex-sidenav-item>
</ng-container>

